import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { downloadErrorAlert, saveAsFile } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/homeworks/HomeworksAction";
import * as uiHelpers from "../HomeworksUIHelpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useHomeworksUIContext } from "../HomeworksUIContext";

export function HomeworksTable() {
  // Homeworks UI Context
  const homeworksUIContext = useHomeworksUIContext();
  const homeworksUIProps = useMemo(() => {
    return {
      queryParams: homeworksUIContext.queryParams,
      setQueryParams: homeworksUIContext.setQueryParams,
      openHomeworkDetailPage: homeworksUIContext.openHomeworkDetailPage
    };
  }, [homeworksUIContext]);

  // Getting curret state of Homeworks list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.homeworks }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;

    // Homeworks Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getHomeworks(homeworksUIProps.queryParams));
    return () => dispatch(actions.cleanHomeworksState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [homeworksUIProps.queryParams, dispatch]);

  /** Belli Bir Eki İndirir */
  const downloadAttachment = (id, filename) => {
    dispatch(actions.downloadAttachment(id)).then(file => {
      if (!file) {
        downloadErrorAlert();
        return;
      }
      saveAsFile(file, filename);
    })
  }

  // Table columns
  const columns = [
    {
      dataField: "teacher",
      text: "Öğretmen",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "180px",
      }
    },
    {
      dataField: "section",
      text: "Sınıf",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px",
      }
    },
    {
      dataField: "course",
      text: "Ders",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "250px",
      }
    },
    {
      dataField: "homeworkTypeName",
      text: "Ödev Türü",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px",
      }
    },
    {
      dataField: "createDate",
      text: "Tarih",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px",
      }
    },
    {
      dataField: "definition",
      text: "Ödev Tanımı",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "250px",
      }
    },
    {
      dataField: "attachmentName",
      text: "Ek",
      sort: true,
      sortCaret: sortCaret,
      formatter: (cell, row) => (
        <a href="javascript:" onClick={() => downloadAttachment(row.id, row.attachmentName)}>{cell}</a>
      ),
      style: {
        minWidth: "150px"
      }
    },
    {
      dataField: "isEvaluated",
      text: "Durum",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.StatusColumnFormatter,
      style: {
        minWidth: "100px"
      }
    },
    {
      dataField: "detail",
      text: "Detay",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openHomeworkDetailPage: homeworksUIProps.openHomeworkDetailPage
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-1",
      style: {
        minWidth: "90px",
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: homeworksUIProps.queryParams.pageSize,
    page: homeworksUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                homeworksUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}